import { format, formatDistanceToNow, parseISO } from 'date-fns';

export function formatDate(iso) {
  if (!iso) return '—';
  try { return format(parseISO(iso), 'MMM d, yyyy'); } catch { return iso; }
}

export function formatDateTime(iso) {
  if (!iso) return '—';
  try { return format(parseISO(iso), 'MMM d, yyyy h:mm a'); } catch { return iso; }
}

export function timeAgo(iso) {
  if (!iso) return '';
  try { return formatDistanceToNow(parseISO(iso), { addSuffix: true }); } catch { return ''; }
}

export function formatScore(score) {
  if (score == null) return '—';
  return `${Number(score).toFixed(1)}%`;
}

export function formatDuration(seconds) {
  if (!seconds) return '0m';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

/**
 * Format a module's duration. Returns '—' when unknown, '~Xh Ym' when the value
 * was auto-estimated by the server (3 min/slide), or 'Xh Ym' when the editor
 * manually set it.
 */
export function formatModuleDuration(minutes, isEstimated = false) {
  if (minutes == null || minutes <= 0) return '—';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const body = h > 0 ? (m > 0 ? `${h}h ${m}m` : `${h}h`) : `${m} min`;
  return isEstimated ? `~${body}` : body;
}

export function getInitials(name) {
  if (!name) return '?';
  return name.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2);
}

export function scoreColor(pct) {
  if (pct >= 90) return 'text-emerald-500';
  if (pct >= 70) return 'text-blue-500';
  if (pct >= 50) return 'text-amber-500';
  return 'text-red-500';
}

export function progressColor(pct) {
  if (pct >= 90) return 'bg-emerald-500';
  if (pct >= 70) return 'bg-blue-500';
  if (pct >= 50) return 'bg-amber-500';
  return 'bg-red-500';
}
